import request from "@/utils/request";

export function subjectTypeGet(params) {
    return request({
        url: "/api/services/app/SubjectType/Get",
        method: "get",
        params
    });
}

export function subjectTypeGetAll(params) {
    return request({
        url: "/api/services/app/SubjectType/GetAll",
        method: "get",
        params
    });
}

export function subjectTypeGetAllWithDetails(params) {
    return request({
        url: "/api/services/app/SubjectType/GetAllWithDetails",
        method: "get",
        params
    });
}

export function subjectTypeGetAllWithMediaLength(params) {
    return request({
        url: "/api/services/app/SubjectType/GetAllWithMediaLength",
        method: "get",
        params
    });
}

export function subjectTypeGetAllForDropdown(params) {
    return request({
        url: "/api/services/app/SubjectType/GetAllForDropdown",
        method: "get",
        params
    });
}

export function subjectTypeGetCount(params) {
    return request({
        url: "/api/services/app/SubjectType/GetCount",
        method: "get",
        params
    });
}

export function subjectTypeCreate(data) {
    return request({
        url: "/api/services/app/SubjectType/Create",
        method: "post",
        data
    });
}

export function subjectTypeUploadImage(data) {
    return request({
        url: "/api/services/app/SubjectType/UploadImage",
        method: "post",
        data
    });
}

export function subjectTypeUpdate(data) {
    return request({
        url: "/api/services/app/SubjectType/Update",
        method: "put",
        data
    });
}

export function subjectTypeUpdateSequence(data) {
    return request({
        url: "/api/services/app/SubjectType/UpdateSequence",
        method: "put",
        data
    });
}

export function subjectTypeDelete(params) {
    return request({
        url: "/api/services/app/SubjectType/Delete",
        method: "delete",
        params
    });
}



// WEBPACK FOOTER //
// ./src/api/subject_type.js